import React, { FunctionComponent } from "react";
import { MenuItem, Stack } from "@mui/material";
import { IShelving } from "../../../hooks/shelvings";
import { ShelvingUtilities } from "../../../models/ShelvingUtilities";
import styles from "./styles.module.scss";
import { useContextMenu } from "../../../hooks/contextMenu";
import { LayoutOptionsMenu } from "../LayoutOptionsMenu";

export const ShelvingSelectItem: FunctionComponent<IShelvingSelectItemProps> = ({
  shelving,
  onModify,
  onDelete,
  setIsSelectOpen,
  value,
  ...props
}) => {
  const { menuProps, handleContextMenu, handleMenuClose } = useContextMenu();
  return (
    <MenuItem {...props} value={value} onContextMenu={handleContextMenu}>
      <Stack direction={"row"} spacing={2}>
        <div
          className={styles.imageDiv}
          style={{ backgroundImage: `url(${ShelvingUtilities.getThemeImage(shelving.theme)})` }}
        />
        <p className={styles.name}>{shelving.name}</p>
      </Stack>
      <LayoutOptionsMenu
        menuProps={menuProps}
        handleMenuClose={handleMenuClose}
        onModify={onModify}
        onDelete={onDelete}
        setIsSelectOpen={setIsSelectOpen}
      />
    </MenuItem>
  );
};

interface IShelvingSelectItemProps {
  shelving: IShelving;
  onModify: () => void;
  onDelete: () => void;
  setIsSelectOpen: (isSelectOpen: boolean) => void;
  value: string;
}
